import {ajax} from '../modules/ajax';
import {event} from '../modules/event';
import Vote from '../modules/Vote';
import Rating from '../modules/Rating';


class MyWidgetFilms {
	constructor(wrapper){
        this._createElements(wrapper);
        this._createFilmAll();
	}

	_createElements(wrapper){
        var parent = this;
        this.wrapper = wrapper;
        this.filmAll = this.wrapper.querySelectorAll('[data-myWidgetFilms-modules]');
        this.ajaxUrl= this._defineAjaxPart() + '/widget/';
        this.ajaxParamAll = ['release', 'premiere'],
        this.xmlhttp = false;
        this.actions = {
            Vote: function(el){return new Vote(el)},
            Rating: function(el){return new Rating(el)}
        };
        this.Film = class {
            constructor(wrapper){
                this._createElements(wrapper);
                this._createModules(wrapper);
            }

            _createElements(wrapper){
                this.wrapper = wrapper;
                this.moduleAll = [];
                //например, голосовать можно много раз и  тогда можно отправить несколько запров - полуится три фильиа в виджете, повторно не отправляем..
                this.isSending = false;
            }

            _createModules(){
                var self = this,
                    nameAll = this.wrapper.getAttribute('data-myWidgetFilms-modules').split(' ');

                for(var m=0,n=nameAll.length; m<n; m++){
                    if(parent.actions[nameAll[m]]) {
                        var module = parent.actions[nameAll[m]](this.wrapper)
                        module.successExec = function(){

                            if(self.isSending) return false;
                            self.isSending = true;

                            parent._showOther.call(parent, self);
                        }
                        this.moduleAll.push(module);
                    }
                }
            }

            _delModuleAll(){
                for(var i=0,j=this.moduleAll.length; i<j; i++){
                    if(this.moduleAll[i].del) this.moduleAll[i].del();
                }
                this.moduleAll = [];
            }

            del(){
                parent.wrapper.removeChild(this.wrapper);
                this._delModuleAll();
                delete this.wrapper;
                delete this.filmAll;
            }
        }
	}

    _createFilmAll(){
        for(var i=0,j=this.filmAll.length; i<j; i++){
            new this.Film(this.filmAll[i]);
        }
    }

	_defineAjaxPart(){
		var part = (window.location + '').indexOf('/build/') === -1 ? '' : 'layouts';
		return part;
	}

    _showOther(film){
        var self = this;
        ajax({
            url: this.ajaxUrl + this.ajaxParamAll[Math.round(Math.random())],
            method: 'POST',
            callback: function(msg){
                var msg = JSON.parse(msg);
                if(msg.status){
                    var container = document.createElement('div'),
                        newFilmEl;

                    container.innerHTML = msg.content;
                    newFilmEl = container.firstChild;
                    new self.Film(newFilmEl);
                    self.wrapper.appendChild(newFilmEl);
                    container = false;
                    film.del();
                }
                else {
                    film.isSending = false;
                }
                film = null;
            }
        });
    }
};

export {MyWidgetFilms};